const productBase = require('../product/base');
const petProfilerHelper = require('../product/petProfilerHelper');
const $body = $('body');

module.exports = {
    togglePetProfilerAllergies: function () {
        $body.on('change', '.js-pet-profiler-allergies-switch', function () {
            const $allergiesContainer = $('.js-pet-profiler-allergies-container');
            const $allergiesSwitch = $(this);
            const isChecked = $allergiesSwitch.is(':checked');
            $allergiesContainer.toggleClass('d-none', !isChecked);
            if (isChecked) {
                sessionStorage.setItem('petProfilerAllergies', 'true');
            } else {
                sessionStorage.removeItem('petProfilerAllergies');
            }
        });
    },

    setPetProfilerDogName: function () {
        $body.on('focusout', '.js-pet-profiler-dog-name-input', function () {
            const $input = $(this);
            const dogName = $input.val();
            const setPetDataURL = $input.data('set-pet-data');
            if (!dogName || (dogName && dogName.length === 0) || !setPetDataURL) {
                return;
            }
            $.spinner().start();
            $.ajax({
                url: setPetDataURL,
                method: 'GET',
                data: { dogName: dogName }
            }).done((response) => {
                $body.find('.js-total-calories-container').html(response.html);
            }).always(() => {
                $.spinner().stop();
            });
        });
    },

    setPetProfilerDogWeight: function () {
        $body.on('focusout', '.js-pet-profiler-dog-weight-input', function () {
            $.spinner().start();
            const $input = $(this);
            var dogWeight = $input.val();
            dogWeight = dogWeight.replace('kg', '');
            dogWeight = parseFloat(dogWeight);
            const setPetDataURL = $input.data('set-pet-data');
            if (!dogWeight || isNaN(dogWeight) || (dogWeight && dogWeight.length === 0) || !setPetDataURL) {
                $.spinner().stop();
                return;
            }
            var calorieCalculatorEndpoint = $input.data('calorie-calculator-endpoint');
            var petData = {
                isSterilized: false,
                weight: parseFloat(dogWeight) * 1000,
                bodyCondition: 'IDEAL',
                activityLevel: 'ACTIVE',
                birthDate: '2023-01-15T00:00:00.000Z',
                weightChangeDesire: 'STAY',
            };
            $.ajax({
                url: calorieCalculatorEndpoint,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(petData),
            }).done(response => {
                var dogData = {};
                dogData.dogWeight = dogWeight;
                dogData.caloricNeeds = response.caloricNeeds;
                dogData.currentPids = JSON.parse(localStorage.getItem('currentPids')) || [];
                $input.val(dogWeight + 'kg');

                $.ajax({
                    url: setPetDataURL,
                    method: 'GET',
                    data: { dogData: JSON.stringify(dogData) }
                }).done((response) => {
                    $body.find('.js-total-calories-container').html(response.html);
                }).always(() => {
                    $.spinner().stop();
                });
            });
        });
    },

    petProfilerDogNameInput: function () {
        $body.on('focusout', '.js-pet-profiler-name-input', function () {
            const $dogNameInput = $(this);
            const $viewPlanBtn = $('.js-pet-profiler-view-plan-btn');
            const petName = $dogNameInput.val();
            const petNameText = $viewPlanBtn.data('pet-name-text');
            $viewPlanBtn.text(petNameText.replace('{0}', petName));
        });
    },

    loadPetProfilerMiniCart: function () {
        $(window).on('load', function () {
            const $petProfilerSearchResults = $('.js-pet-profiler-search-results');

            if (!$petProfilerSearchResults.length) {
                return;
            }
            let currentPids = [];
            let miniCartUrl = $petProfilerSearchResults.data('pet-profile-mini-cart-url');
            try {
                currentPids = JSON.parse(localStorage.getItem('currentPids'));
            } catch (e) {
                return;
            }

            if (currentPids && currentPids.length > 0) {
                productBase.petProfilerMiniCart(currentPids, miniCartUrl);
            }
        });
    },

    togglePetProfilerAllergiesOnLoad: function () {
        $(window).on('load', function () {
            const hasSelectedAllergens = sessionStorage.getItem('petProfilerAllergies') === 'true';
            const $allergiesContainer = $('.js-pet-profiler-allergies-container');
            const $allergiesSwitch = $('.js-pet-profiler-allergies-switch');

            if (hasSelectedAllergens) {
                $allergiesContainer.removeClass('d-none');
                $allergiesSwitch.prop('checked', true);
            } else {
                $allergiesContainer.addClass('d-none');
                $allergiesSwitch.prop('checked', false);
            }
        });
    },

    mergePetProfilerCart: function () {
        $(window).on('load', function () {
            const $petProfilerSearchResults = $('.js-pet-profiler-search-results');
            if ($petProfilerSearchResults.length) {
                return;
            }

            var $body = $('body');
            let currentPids = [];
            let mergeCartUrl = $body.find('#petProfilerMergeCartUrl').data('url');
            try {
                currentPids = JSON.parse(localStorage.getItem('currentPids'));
            } catch (e) {
                return;
            }

            if (currentPids && currentPids.length > 0) {
                $.spinner().start();
                $.ajax({
                    url: mergeCartUrl,
                    method: 'POST',
                    data: {
                        currentPids: JSON.stringify(currentPids)
                    }
                }).done(() => {
                    localStorage.removeItem('currentPids');
                    window.location.reload();
                });
            }
        });
    },

    viewCart: function () {
        $body.on('click', '.js-pet-profiler-mobile-view-cart', function (e) {
            e.preventDefault();
            const $miniCart = $body.find('.js-pet-profiler-mini-cart-content');
            $(window).scrollTop($miniCart.offset().top - 100);
        });
    },

    showPetProfilerRefinementFilters: function () {
        $body.on('click', '.js-pet-profiler-search-bar-icon', function () {
            const $refinementFilters = $('.js-pet-profiler-refinement-bar');
            const $miniCart = $('.js-pet-profiler-minicart__content');
            const $productGrid = $('.js-product-grid-container');
            const $searchBarIconSelected = $('.js-pet-profiler-search-bar-icon-selected');
            const $miniCartDisabled = $body.find('.js-pet-profiler-mini-cart-disabled');
            const $miniCartClosed = $body.find('.js-pet-profiler-mini-cart-closed');
            $refinementFilters.toggleClass('d-none active-filters');
            $miniCart.toggleClass('d-none');
            $productGrid.removeClass('col-md-12').addClass('col-md-9');
            $searchBarIconSelected.removeClass('d-none');
            $miniCartDisabled.addClass('d-none');
            $miniCartClosed.removeClass('d-none');
            $(this).addClass('d-none');
            // $('body').find('.js-pet-profiler-search-results-content').addClass('col-md-12').removeClass('col-md-9');
        });
    },

    hidePetProfilerRefinementFilters: function () {
        $body.on('click', '.js-pet-profiler-search-bar-icon-selected', function () {
            const $refinementFilters = $('.js-pet-profiler-refinement-bar');
            const $miniCart = $('.js-pet-profiler-minicart__content');
            const $productGrid = $('.js-product-grid-container');
            const $searchBarIcon = $('.js-pet-profiler-search-bar-icon');
            const $miniCartDisabled = $body.find('.js-pet-profiler-mini-cart-disabled');
            const $miniCartClosed = $body.find('.js-pet-profiler-mini-cart-closed');
            $refinementFilters.toggleClass('d-none active-filters');
            $miniCart.toggleClass('d-none');
            $productGrid.removeClass('col-md-12').addClass('col-md-9');
            $searchBarIcon.removeClass('d-none');
            $miniCartDisabled.removeClass('d-none');
            $miniCartClosed.addClass('d-none');
            $(this).addClass('d-none');
            // $('body').find('.js-pet-profiler-search-results-content').addClass('col-md-12').removeClass('col-md-9');
        });
    },

    showMiniCartPetProfiler: function () {
        $body.on('click', '.js-pet-profiler-mini-cart-closed', function () {
            $body.find('.js-pet-profiler-search-bar-icon-selected').trigger('click');
        });
    },

    collapseSearchForm: function () {
        $body.on('click', '.js-pet-profiler-view-plan-btn', function () {
            const $searchForm = $('.js-pet-profiler-search-form');
            const $formCollapseContainer = $('.js-pet-profiler-form-collapse-container');
            $searchForm.addClass('d-none');
            $formCollapseContainer.removeClass('d-none');
        });
    },

    uncollapseSearchForm: function () {
        $body.on('click', '.js-pet-profiler-collapse-search-form', function () {
            const $searchForm = $('.js-pet-profiler-search-form');
            const $formCollapseContainer = $('.js-pet-profiler-form-collapse-container');
            $searchForm.removeClass('d-none');
            $formCollapseContainer.addClass('d-none');
        });
    },

    togglePetProfilerMiniCart: function () {
        $body.on('click', '.js-pet-profiler-minicart-icon', function () {
            const $miniCart = $('.js-pet-profiler-minicart__content');
            const $refinementFilters = $('.js-pet-profiler-refinement-bar');
            const $productGrid = $('.js-product-grid-container');
            $miniCart.toggleClass('d-none');
            $refinementFilters.toggleClass('d-none active-filters');
            $productGrid.removeClass('col-md-12').addClass('col-md-9');
            $(this).addClass('d-none');
        });
    },

    toggleStickyViewCart: function () {
        console.log('toggleStickyViewCart');
        $(window).on('scroll', function () {
            const $stickyBar = $body.find('.js-pet-profiler-mobile-sticky');
            const productGrid = $body.find('.js-product-grid-container')[0];
            if (!productGrid) return;
            const rect = productGrid.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;
            $stickyBar.toggleClass('d-none', !inView);
        });
    },

    toggleRefinementActiveState: function () {
        $body.on('click', '.js-pet-profiler-refinement', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $refinementGroup = $this.closest('.js-pet-profiler-refinement-group');
            const isActive = $this.hasClass('active');

            if ($refinementGroup.hasClass('js-pet-profiler-life_stage')) {
                $refinementGroup.find('.js-pet-profiler-refinement').removeClass('active');
            } else if ($refinementGroup.hasClass('js-pet-profiler-specialty')) {
                $refinementGroup.find('.js-pet-profiler-refinement').removeClass('active');
            } else if ($refinementGroup.hasClass('js-pet-profiler-allergies')) {
                $refinementGroup.find('.js-pet-profiler-refinement').removeClass('active');
            }

            if (!isActive) {
                $this.addClass('active');
            }
        });
    },

    getRefinedSearchResults: function () {
        $body.on('click', '.js-pet-profiler-view-plan-btn', function (e) {
            //https://bdgx-007.dx.commercecloud.salesforce.com/on/demandware.store/Sites-NaturesMenu-d2c-Site/en/Search-Show?cgid=raw-dog-food&prefn1=life_stage&prefv1=puppy&prefn2=specialty&prefv2=grain+free&prefn3=allergens&prefv3=Goose
            e.preventDefault();
            const refinementUrl = petProfilerHelper.constructPetProfilerURL();
            const $searchResults = $body.find('.js-pet-profiler-search-results');
            const $collapseMsg = $('.js-pet-profiler-collapse-msg');
            const activeLifeStage = $('.js-pet-profiler-life_stage .js-pet-profiler-refinement.active');
            const activeSpecialty = $('.js-pet-profiler-specialty .js-pet-profiler-refinement.active');
            const name = $collapseMsg.data('name') || $body.find('.js-pet-profiler-dog-name-input').val();
            let weight = $collapseMsg.data('weight') || $body.find('.js-pet-profiler-dog-weight-input').val();
            weight = parseInt(weight, 10);
            const msgEmpty = $collapseMsg.data('msg-empty');
            const noWeight = $collapseMsg.data('no-weight');
            const noFilters = $collapseMsg.data('no-filters');
            const noGrain = $collapseMsg.data('no-grain');
            const msg = $collapseMsg.data('msg');
            let finalText = '';

            if (activeLifeStage.length > 0 && activeSpecialty.length > 0) {
                finalText = msg.replace('{0}', name).replace('{1}', weight).replace('{2}', activeLifeStage.text().trim()).replace('{3}', activeSpecialty.text().trim());
            } else if (activeLifeStage.length > 0 && activeSpecialty.length === 0) {
                finalText = noGrain.replace('{0}', name).replace('{1}', weight).replace('{2}', activeLifeStage.text().trim());
            } else if (activeLifeStage.length === 0 && activeSpecialty.length === 0 && name.length > 0 && weight.length > 0) {
                finalText = noFilters.replace('{0}', name).replace('{1}', weight);
            } else if (name && !weight) {
                finalText = noWeight.replace('{0}', name).replace('{1}', weight).replace('{2}', activeSpecialty.text().trim());
            } else {
                finalText = msgEmpty;
            }

            if (finalText) {
                $collapseMsg.text(finalText);
            }

            $.ajax({
                url: refinementUrl,
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                dataType: 'json',
                success: function (response) {
                    /* const $parsedHtml = $($.parseHTML(response.html));
                    const $targetContainer = $parsedHtml.filter('.js-pet-profiler-search-results');
                    if ($targetContainer.length > 0) {
                        const innerContent = $targetContainer.html();
                        console.log('Inner content:', innerContent);
                        $searchResults.html(innerContent);
                    } else {
                        console.log('Target container not found, trying direct approach');
                        const innerContent = $parsedHtml.html();
                        console.log('Direct inner content:', innerContent);
                        $searchResults.html(innerContent);
                    } */
                }
            });
        });
    },

    addToCart: function () {
        $body.on('click', '.js-pet-profiler-add-to-cart', function () {
            const $this = $(this);
            const pid = $this.data('pid');
            const qty = $body.find('.qty-input').val();
            const miniCartUrl = $this.data('pet-profile-mini-cart-url');
            let currentPids = [];
            try {
                currentPids = JSON.parse(localStorage.getItem('currentPids')) || [];
            } catch (e) {
                currentPids = [];
            }

            if (currentPids.length) {
                currentPids.forEach(lsProduct => {
                    if (lsProduct.pid === pid) {
                        lsProduct.qty += 1;
                    } else {
                        currentPids.push({
                            pid: pid,
                            qty: qty,
                            options: []
                        });
                    }
                });
            } else {
                currentPids.push({
                    pid: pid,
                    qty: 1,
                    options: []
                });
            }

            petProfilerHelper.petProfilerMiniCart(currentPids, miniCartUrl);
            localStorage.setItem('currentPids', JSON.stringify(currentPids));
            $body.find('.js-added-to-cart-banner').removeClass('d-none').addClass('d-flex');
            setTimeout(() => {
                $body.find('.js-added-to-cart-banner').addClass('d-none').removeClass('d-flex');
            }, 3000);
        });
    },

    quickViewClose: function () {
        $body.on('click', '.quickview-close', function () {
            $body.find('#petProfilerAddToCartModal').remove();
            $body.removeClass('modal-open');
        });
    },

    updatePidValue: function () {
        $body.on('click', '.tab-bundle', function () {
            const $this = $(this);
            const pid = $this.data('custom-pid');
            const $atcButton = $body.find('.js-pet-profiler-add-to-cart');
            $atcButton.attr('data-pid', pid);
        });
    }
};
